import { gql } from '@/__generated__';

export const shippingOrderDocument = gql(/* GraphQL */ `
  query ShippingOrder($where: OrderWhereUniqueInput!) {
    order(where: $where) {
      id
      package
      status
      total
      createdAt
      updatedAt
      packedBy
      shipment {
        id
        externalId
        parcels {
          id
          externalId
          trackingNumber
          weight
          statuses {
            id
            statusCode
            statusDate
            statusDescription
            statusInfo
            depotCity
            depotNumber
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      customer {
        id
        name
        avatar
      }
      shippingMethod {
        id
        name
      }
      paymentMethod {
        id
        name
      }
      payments {
        id
        method
        amount
        status
        referenceId
        createdAt
        updatedAt
      }
      address {
        name
        streetLine
        streetDescription
        city
        postCode
        country
        phone
      }
      lines {
        id
        type
        status
        code
        name
        description
        price
        productVariantId
        shippingMethodId
        paymentMethodId
      }
    }
  }
`);

export const orderDocument = gql(/* GraphQL */ `
  query Order($where: OrderWhereUniqueInput!) {
    order(where: $where) {
      id
      status
      shippingMethod {
        id
        name
      }
      paymentMethod {
        id
        name
      }
      ...OrderDetails
      address {
        ...OrderAddressDetails
      }
      customer {
        ...OrderCustomerDetails
        messages(orderBy: [{ createdAt: desc }], take: 100) {
          id
          body
          isEcho
          createdAt
          customer {
            id
            name
            avatar
          }
        }
        metadata
      }
      lines {
        ...OrderLineDetails
      }
      cancellations {
        ...OrderCancellationDetails
      }
    }
  }
`);

export const countOrdersDocument = gql(/* GraphQL */ `
  query CountOrders($where: OrderWhereInput!) {
    countOrders(where: $where)
  }
`);

export const liveOrdersSummaryDocument = gql(/* GraphQL */ `
  query LiveOrdersSummary($where: OrderWhereInput!) {
    liveOrdersSummary(where: $where) {
      all {
        count
        total
      }
      bank {
        count
        total
      }
      card {
        count
        total
      }
      cod {
        count
        total
      }
      cash {
        count
        total
      }
      created {
        count
        total
      }
      confirmed {
        count
        total
      }
      processed {
        count
        total
      }
      shipped {
        count
        total
      }
      reviewing {
        count
        total
      }
      delivered {
        count
        total
      }
      reserved {
        count
        total
      }
      packed {
        count
        total
      }
      leftCods {
        count
        total
      }
      leftPersonal {
        count
        total
      }
      leftBank {
        count
        total
      }
      leftCard {
        count
        total
      }
      unpaidBank {
        count
        total
      }
      unpaidCard {
        count
        total
      }
      unpaidCods {
        count
        total
      }
      paymentProblems {
        count
        total
      }
    }
  }
`);

export const ordersDocument = gql(/* GraphQL */ `
  query Orders(
    $where: OrderWhereInput
    $skip: Int
    $take: Int
    $orderBy: [OrderOrderByWithRelationInput!]
  ) {
    orders(where: $where, skip: $skip, take: $take, orderBy: $orderBy) {
      id
      package
      status
      total
      createdAt
      updatedAt
      packedBy
      customer {
        id
        name
        avatar
        metadata
      }
      address {
        phone
      }
      live {
        id
        name
        description
      }
      shippingMethod {
        id
        name
      }
      paymentMethod {
        id
        name
      }
      payments {
        id
        status
        amount
        method
        createdAt
        updatedAt
        metadata
      }
      invoice {
        id
        number
        url
        sent
      }
    }
  }
`);

export const ordersTabletDocument = gql(/* GraphQL */ `
  query OrdersTablet($where: OrderWhereInput, $orderBy: [OrderOrderByWithRelationInput!]) {
    orders(where: $where, orderBy: $orderBy) {
      id
      package
      total
      packedBy
      customer {
        id
        name
        avatar
      }
      address {
        phone
      }
      live {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`);

export const ordersTabletSummaryDocument = gql(/* GraphQL */ `
  query OrdersTabletSummary($where: OrderWhereInput!) {
    ordersTabletSummary(where: $where) {
      total
      count
    }
  }
`);

export const personalPickupOrdersDocument = gql(/* GraphQL */ `
  query PersonalPickupOrders($search: PersonalPickupSearch) {
    personalPickupOrders(search: $search) {
      orders {
        id
        package
        total
        packedBy
        customer {
          id
          name
          avatar
        }
        address {
          phone
        }
        live {
          id
          name
        }
        createdAt
        updatedAt
      }
      count
      total
    }
  }
`);

export const personalPickupDeliveredOrdersDocument = gql(/* GraphQL */ `
  query PersonalPickupDeliveredOrders {
    personalPickupDeliveredOrders {
      orders {
        id
        package
        total
        packedBy
        customer {
          id
          name
          avatar
        }
        address {
          phone
        }
        live {
          id
          name
        }
        createdAt
        updatedAt
      }
      count
      total
    }
  }
`);
